import { motion } from "framer-motion";
import { useCartStore } from "../stores/useCartStore";
import { useUserStore } from "../stores/useUserStore";
import { Link, useNavigate } from "react-router-dom";
import { MoveRight } from "lucide-react";

const OrderSummary = () => {
	const { total, subtotal, coupon, isCouponApplied, cart, shippingCost } = useCartStore();
	const { user } = useUserStore();
	const navigate = useNavigate();

	// חישובי מע"מ - המחירים כוללים מע"מ של 18%
	const totalWithDiscount = total; // המחיר הסופי כולל מע"מ
	const priceBeforeVAT = totalWithDiscount / 1.18; // מחיר לפני מע"מ
	const vatAmount = totalWithDiscount - priceBeforeVAT; // סכום המע"מ
	
	const savings = subtotal - total;
	const formattedSubtotal = subtotal.toFixed(2);
	const formattedTotal = totalWithDiscount.toFixed(2);
	const formattedPriceBeforeVAT = priceBeforeVAT.toFixed(2);
	const formattedVAT = vatAmount.toFixed(2);
	const formattedSavings = savings.toFixed(2);

	const handlePayment = () => {
		// בדיקה שיש פריטים בעגלה לפני המעבר לתשלום
		if (cart.length === 0) {
			alert("העגלה ריקה! הוסף מוצרים לפני המשך לתשלום.");
			return;
		}
		
		// בדיקה שהמשתמש מחובר לפני המעבר לתשלום
		if (!user) {
			alert("יש להתחבר לפני המשך לתשלום");
			navigate('/login');
			return;
		}
		
		// 🇮🇱 Navigate to Israeli payment page using React Router
		navigate('/payment');
	};

	return (
		<motion.div
			className='space-y-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm sm:p-6'
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
		>
			<p className='text-xl font-semibold text-brand-primary'>סיכום הזמנה</p>

			<div className='space-y-4'>
				<div className='space-y-2'>
					<dl className='flex items-center justify-between gap-4'>
						<dt className='text-base font-normal text-gray-600'>מחיר מקורי</dt>
						<dd className='text-base font-medium text-gray-900'>₪{formattedSubtotal}</dd>
					</dl>

					{savings > 0 && (
						<dl className='flex items-center justify-between gap-4'>
							<dt className='text-base font-normal text-gray-600'>חיסכון</dt>
							<dd className='text-base font-medium text-brand-primary'>-₪{formattedSavings}</dd>
						</dl>
					)}

						{coupon && isCouponApplied && (
						<dl className='flex items-center justify-between gap-4'>
								<dt className='text-base font-normal text-gray-600'>קופון ({coupon.code})</dt>
							<dd className='text-base font-medium text-brand-primary'>-{coupon.discountPercentage}%</dd>
						</dl>
					)}
					
					<dl className='flex items-center justify-between gap-4'>
						<dt className='text-base font-normal text-gray-600'>משלוח</dt>
						<dd className='text-base font-medium text-gray-900'>{shippingCost === 0 ? 'חינם' : `₪${shippingCost.toFixed(2)}`}</dd>
					</dl>
					
						<dl className='flex items-center justify-between gap-4 border-t border-gray-200 pt-2'>
							<dt className='text-base font-normal text-gray-600'>מחיר לפני מע&quot;מ</dt>
							<dd className='text-base font-medium text-gray-900'>₪{formattedPriceBeforeVAT}</dd>
					</dl>
					
						<dl className='flex items-center justify-between gap-4'>
							<dt className='text-base font-normal text-gray-600'>מע&quot;מ (18%)</dt>
							<dd className='text-base font-medium text-gray-900'>₪{formattedVAT}</dd>
					</dl>
					
						<dl className='flex items-center justify-between gap-4 border-t border-gray-200 pt-2'>
							<dt className='text-base font-bold text-gray-900'>סה&quot;כ כולל מע&quot;מ</dt>
						<dd className='text-base font-bold text-brand-primary'>₪{formattedTotal}</dd>
					</dl>
				</div>

				<motion.button
					className='flex w-full items-center justify-center rounded-lg bg-brand-primary px-5 py-2.5 text-sm font-medium text-white bg-brand-primary-hover focus:outline-none focus:ring-4'
					whileHover={{ scale: 1.05 }}
					whileTap={{ scale: 0.95 }}
					onClick={handlePayment}
					style={{'--tw-ring-color': 'rgba(100, 13, 70, 0.3)'}}
				>
					המשך לתשלום
				</motion.button>

				<div className='flex items-center justify-center gap-2'>
					<span className='text-sm font-normal text-gray-500'>או</span>
					<Link
						to='/'
						className='inline-flex items-center gap-2 text-sm font-medium text-brand-primary underline text-brand-primary-hover hover:no-underline'
					>
						המשך בקניות
						<MoveRight size={16} />
					</Link>
				</div>
			</div>
		</motion.div>
	);
};
export default OrderSummary;
